<template>
    <div class="listRight">
        <p style="line-height: 100px; color:#cbcbcb; text-align: center;border: 1px solid #ededed;height: 380px;">公司动态 目前为空～</p>
    </div>
</template>

<style lang="scss">
    .listRight {
        padding-left: 30px;
        flex: 1;
        .item {
            display: flex;
            flex-flow: nowrap row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
            height: 176px;
            .imageLeft {
                width: 278px;
                height: 176px;
                img {
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            .newRight {
                height: 176px;
                padding-left: 20px;
                background: rgba(250, 250, 250, 1);
                flex: 1;

                display: flex;
                flex-flow: nowrap row;
                justify-content: space-between;
                align-items: center;
                .newTitle {
                    width: 200px;
                    height: 136px;
                    padding: 40px 0;
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: space-between;
                    align-items: flex-start;
                    a {
                        display: block;
                        font-size: 20px;
                        font-weight: bold;
                        line-height: 28px;
                        color: #323232;
                    }
                    span {
                        font-size: 14px;
                    }
                }
                .newDescription {
                    flex: 1;
                    display: flex;
                    flex-flow: column nowrap;
                    justify-content: space-between;
                    align-items: flex-start;
                    height: 130px;
                    padding: 0 20px;
                    border-left: 1px solid #ddd;
                    span {
                        font-size: 14px;
                        color: rgba(50, 50, 50, 0.6);
                        line-height: 26px;
                    }
                    a {
                        display: block;
                        width: 96px;
                        height: 36px;
                        font-size: 14px;
                        font-weight: normal;
                        text-align: center;
                        line-height: 36px;
                        color: #fff;
                        background: rgba(18, 10, 76, 0.4);
                        &:hover {background: rgba(18, 10, 76, 0.8);}
                    }
                }
            }
        }
    }
</style>


<script>
import store from '../vuex'
export default {
  data() {
      return {
        bannerObj: {
            imgUrl: require('../assets/images/news.png'),
            text: 'NEWS',
        }
      }
  },
  components:{},
  store,
}
</script>

